import { useState, useEffect, useCallback } from "react"

export const useFetchResource = (url, options) => {
  const [fetching, setFetching] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [currentUrl, setCurrentUrl] = useState(url);

  const fetchData = useCallback(() => {
    const {method = 'get', headers, ...otherOptions} = options || {};

    setFetching(true);
    setData(null);
    setError(null);

    fetch(currentUrl, {
      method,
      headers: {
        ...headers,
        'content-type': 'application/json',
        'authorization': `Bearer ${localStorage.getItem('token')}`
      },
      ...otherOptions
    })
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      setError(res.statusText);
      return null;
    })
    .then((body) => {
      if (body) {
        setData(body);
      }
    })
    .catch(setError)
    .finally(() => setFetching(false))
  }, [currentUrl, options]);

  useEffect(() => {
    fetchData(currentUrl);
  }, [currentUrl, fetchData]);

  return {fetching, data, error, retry: fetchData, updateUrl: setCurrentUrl};
}
